import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function EpkViewCard({ EpkInfo }) {
  const { t } = useTranslation();
  const BANNER_IMG = `${process.env.REACT_APP_AWS_URL}/${EpkInfo.banner_url}`;
  return (
    <Link
      to={EpkInfo._id ? `/epk/${EpkInfo._id}` : "/"}
      className="tw-block tw-rounded-xl tw-overflow-hidden tw-bg-[#280D41] tw-border tw-border-white/10 tw-transition-transform hover:tw-scale-[1.02] tw-no-underline"
    >
      <div className="tw-h-36 tw-w-full">
        <img
          className="tw-h-full tw-w-full tw-object-cover"
          src={BANNER_IMG}
          alt={EpkInfo.title || t("Movie Poster")}
        />
      </div>
      <div className="tw-px-3 tw-py-2">
        <p className="tw-truncate tw-text-sm tw-font-medium tw-text-white tw-m-0">{EpkInfo.title}</p>
      </div>
    </Link>
  );
}
